import React from "react";
import styles from "./HeadingComponent.module.css";
const HeadingComponent = (props) => {
  return (
    <span
      id={props?.id}
      {...props}
      ref={props?.ref}
      className={`${styles.text} ${props?.className}`}
      onClick={props.onClick}
      style={{
        textAlign: props?.textAlign ? props?.textAlign : "left",
        padding: props?.padding ? props?.padding : "10px",
        color: props?.color ? props?.color : "var(--black-color)",
        fontFamily: props?.fontFamily ? props?.fontFamily : "Urbanist-bold",
        fontSize: props?.fontSize
          ? props?.fontSize
          : " var(--heading-font-size)",
      }}
    >
      {props.text}
      {props.children}
    </span>
  );
};

export default HeadingComponent;
